import { render, staticRenderFns } from "./AddLocationTemplate.vue?vue&type=template&id=af0320c8&scoped=true"
import script from "./AddLocationTemplate.vue?vue&type=script&lang=js"
export * from "./AddLocationTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddLocationTemplate.vue?vue&type=style&index=0&id=af0320c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0320c8",
  null
  
)

export default component.exports